export default "__VITE_ASSET__CBkvPaJl__"